// This is a fetch with the special Vercel skew protection headers
// import "./utils/global-fetch";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { registerPWA } from "./pwa";
import "./styles/fonts.css";

registerPWA();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
